import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import "../Css/Pages/Certificates.css";
import { CertificatesData } from "../Data/CertificatesData";
import { FaAngleRight } from "react-icons/fa";

const Certificates = () => {
  return (
    <>
      <Header />
      <div className="portfolyo-page-header">
        <div className="portfolyo-page-title">
          <h1>Sertifikalarım</h1>
        </div>
        <div className="portfolyo-page-breadcrumb">
          <a href="/">Anasayfa</a>
          <FaAngleRight className="portfolyo-page-breadcrumb-icon" />
          <strong>Sertifikalarım</strong>
        </div>
      </div>
      <div className="certificates-page-content-container">
        {CertificatesData.map((product) => (
          <div className="certificates-page">
            <a
              href={product.file}
              target="_blank"
              rel="noopener noreferrer"
              className="certificates-page-link"
            >
              <img
                src={product.image}
                alt={product.title}
                className="certificates-page-image"
              />
            </a>
            <div className="certificates-page-wrapper">
              <a
                href={product.file}
                target="_blank"
                rel="noopener noreferrer"
                className="certificates-page-wrapper-link"
              >
                <div className="certificates-page-details">
                  <strong className="certificates-page-name">
                    {product.title}
                  </strong>
                  <span className="certificates-page-category">{product.date}</span>
                </div>
              </a>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default Certificates;
